import Styles from "./styles.module.css";
import JourneyCard from "./JourneyCard";
import ProgramModal from "./ProgramModal";
import { useState } from "react"
import useFetchPrograms from "../../hooks/useFetchPrograms";
import SkeletonGrid from "../../components/SkeletonLoader/SkeletonGrid";
import SkeletonLoader from "../../components/SkeletonLoader/SkeletonLoader";

const Dashboard = () => {
    const [selectedProgram, setSelectedProgram] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)

    const {data: programs, error} = useFetchPrograms("https://api.evolveinc.in/api/v3/journeys/")
    console.log(programs)

    const handleCardClick = (program) => {
        setSelectedProgram(program);
        setModalOpen(true)
        
    };

    const closeModal = () => {
        setSelectedProgram(null)
        setModalOpen(false)
    }

    const loading = !programs || programs.length === 0;
    // console.log("loading: ", loading)

    return (
    <div className={Styles.ProgramDashboard}>
        <div style={{textAlign: "left", paddingLeft: "1%"}}>
            <h1 style={{fontFamily: "GothamRounded", fontWeight: "370"}}>Programs</h1>
        </div>

        {modalOpen && selectedProgram && <ProgramModal open={modalOpen} program={selectedProgram} onClose={closeModal}/>}
      
      {/* <div className={Styles.ProgramGrid}>
        {loading ? <SkeletonGrid /> : (programs).map((program) => (
            <JourneyCard key={program.id} program={program} onClick={handleCardClick}/>
        ))}
      </div> */}

      {loading ? (
            <div>
                <SkeletonGrid />
            </div>
        ) : (
            <div className={Styles.ProgramGrid}>
                {programs.map((program) => {
                    return <JourneyCard key={program.id} program={program} onClick={handleCardClick}/>
                })}
            </div>
        )}
    </div>
  );
};

export default Dashboard